/**
 * Disqus Logic
 *
 * Use 'https://rockwell-automation.disqus.com/embed.js' for testing purposes when authoring component.
 */
import { Component, registerComponent } from 'js/component.js';

const DISQUS_SELECTOR = '#disqus_thread';

export class Disqus extends Component {
    // Creates Disqus disqus_config function object
    disqusConfigurationFactory(pageUrl, pageIdentifier) {
        // disqus_config function is Disqus loader boiler plate
        // eslint-disable-next-line
        return function disqus_config() {
            this.page.url = pageUrl;
            this.page.identifier = pageIdentifier;
        };
    }

    // Launch Disqus loader boilerplate
    loadDisqus(disqusUrl) {
        const d = document;
        const s = d.createElement('script');
        s.src = disqusUrl;
        s.setAttribute('data-timestamp', +new Date());
        (d.head || d.body).appendChild(s);
    }

    init() {
        // Check to see if comments are enabled and a disqus embed script url is provided
        const { dataset } = this.element;
        if (dataset.enableComments !== 'true' || !dataset.disqusEmbedUrl) {
            return;
        }

        this.disqusConfigurationFactory(
            dataset.pageUrl,
            dataset.pageIdentifier,
        );
        this.loadDisqus(this.element.dataset.disqusEmbedUrl);
    }
}

registerComponent(DISQUS_SELECTOR, Disqus);
